import { createUseStyles } from "react-jss";

export default createUseStyles ( theme => ( {
	root: {
		flexGrow: 1
	},
	menuButton: {
		marginRight: "35px"
	},
	menuItemStyles: {
		color: theme.colors.text.tertiary
	},
	dividerStyles: {
		backgroundColor: theme.colors.border.primary
	},
	iconStyles: {
		filter      : theme.darkMode ? "invert(1)" : "none",
		marginRight : "1.5rem"
	},
	userNameContainer: {
		marginLeft : "15px",
		fontSize   : "14px",
		fontWeight : "bold",
		color      : theme.colors.text.tertiary
	},
	title: {
		flex           : 3,
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center"
	},
	navDrawer: {
		display    : "flex",
		height     : "100vh",
		width      : "100%",
		maxWidth   : "600px",
		background : "rgba(0, 0, 0, 0.75)",
		position   : "fixed",
		top        : "0",
		left       : "0",
		zIndex     : "1200"
	},
	navContainer: {
		width          : "80%",
		maxWidth       : "600px",
		height         : "100vh",
		background     : theme.colors.body.primary,
		overflowY      : "auto",
		display        : "flex",
		flexDirection  : "column",
		justifyContent : "space-between"
	},
	guestContainer: {
		height         : "80px",
		padding        : "20px 15px",
		display        : "flex",
		alignItems     : "center",
		color          : "white",
		justifyContent : "space-between"
	},
	guestIcon: {
		width           : "40px",
		height          : "40px",
		backgroundColor : "rgba(0, 0, 0, 0.3)",
		borderRadius    : "50%",
		display         : "flex",
		alignItems      : "center",
		justifyContent  : "center"
	},
	tabsItem: props => ( {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center",
		width          : props?.isApple ? "-webkit-fill-available" : "30px"
	} ),
	tabsContainer: {
		display            : "flex",
		alignItems         : "center",
		backgroundPosition : "center",
		color              : theme.colors.text.tertiary,
		padding            : "15px 15px",
		transition         : "background 0.8s",
		"&:focus"          : {
			background: "#1566c7 radial-gradient(circle, transparent 1%, #1566c7 1%) center/15000%"
		},
		"&:active": {
			backgroundColor : "#6eb9f7",
			backgroundSize  : "100%",
			transition      : "background 0s"
		}
	},
	tabsContainerDownloadApp: {
		display            : "flex",
		alignItems         : "center",
		backgroundPosition : "center",
		color              : theme.colors.text.tertiary,
		padding            : "20px 15px",
		transition         : "background 0.8s",
		"&:focus"          : {
			background: "#1566c7 radial-gradient(circle, transparent 1%, #1566c7 1%) center/15000%"
		},
		"&:active": {
			backgroundColor : "#6eb9f7",
			backgroundSize  : "100%",
			transition      : "background 0s"
		}
	},
	themeSettingContainer: {
		display            : "flex",
		alignItems         : "center",
		backgroundPosition : "center",
		justifyContent     : "space-between",
		color              : theme.colors.text.tertiary,
		padding            : "15px 15px",
		transition         : "background 0.8s"

	},
	appearMenuHeading: {
		display            : "flex",
		alignItems         : "center",
		backgroundPosition : "center",
		color              : theme.colors.text.tertiary,
		padding            : "10px 0",
		paddingLeft        : "15px",
		transition         : "background 0.8s"
	},
	themeOptionContainer: {
		display            : "flex",
		alignItems         : "center",
		backgroundPosition : "center",
		justifyContent     : "space-between",
		color              : theme.colors.text.primary,
		padding            : "15px"

	},
	themeOptionContainerActive: {
		display            : "flex",
		alignItems         : "center",
		backgroundPosition : "center",
		justifyContent     : "space-between",
		color              : theme.colors.text.primary,
		padding            : "15px",
		backgroundColor    : "rgba(18, 107, 213, 0.5)"

	},
	userAvatar: {
		height       : "40px",
		width        : "40px",
		objectFit    : "cover",
		borderRadius : "50%"
	},
	appIconContainer: {
		display     : "flex",
		alignItems  : "center",
		// margin: "20px 0 0",
		/* color: "#343434", */
		color       : "white",
		padding     : "10px 0",
		paddingLeft : "10px",
		width       : "100%",
		bottom      : 0,
		background  : theme.secondaryColor
	},
	appIcon: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center"
	},
	appInstall: {
		margin     : "0",
		marginLeft : "10px",
		fontSize   : "16px"
	},
	pwaButton: {
		height         : "26px",
		width          : "26px",
		backgroundSize : "cover !important"
	},
	menuIcon: {

		width  : "26px",
		filter : theme.darkMode ? "none" : "invert(1)"
	},
	bellIcon: {
		height : "30px",
		width  : "30px"
	},
	logoutContainer: {
		margin          : "5px 0",
		backgroundColor : theme.colors.background.primary
	},
	ellipse: {
		height          : "4px",
		width           : "4px",
		borderRadius    : "50%",
		display         : "inline-block",
		position        : "relative",
		top             : "-4px",
		backgroundColor : "#2283F6"
	}

} ) );
